import { render, staticRenderFns } from "./PlayerConversationCreated.vue?vue&type=template&id=64417797&scoped=true&"
import script from "./PlayerConversationCreated.vue?vue&type=script&lang=js&"
export * from "./PlayerConversationCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64417797",
  null
  
)

export default component.exports